import React, { HTMLAttributes } from 'react'

export const MenuSectionWrapper = ({
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <section className="pb-6" {...props}>
    {children}
  </section>
)

export const MenuSectionHeader = ({
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <header className="mb-4 flex flex-col sm:flex-wrap" {...props}>
    {children}
  </header>
)

export const MenuSectionTitle = ({
  children,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h1 className="my-heading-md sm:grow" {...props}>
    {children}
  </h1>
)

export const MenuSectionSubtitle = ({
  children,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className="my-body-md sm:order-last sm:w-full" {...props}>
    {children}
  </h2>
)
